<template>
    <div class="PageUser">
    	<div v-if="!($route.name.match(/-chart/) || $route.name.match(/-editor/)) && title" class="row margin-bottom-medium">
    		<div class="col-xs-12">
    			<h1 class="st-headline st-headline--1">{{ title }}</h1>
    		</div>
    	</div>
    	<router-view></router-view>
    </div>
</template>

<script>
// Base
import Vue from 'vue';

// Componenets

// funktion

// helper
import help_rest from '@/helpers/rest';
import help_user from '@/helpers/user';

export default {

	name: 'PageUser',

	data(){
		return {
			newChartIDCount: 0,
			olduid: false,
			oldrole: false,
			data: {},
		}
	},

	props: {
		partnerid: {
			default: ''
		},
		uid: {
			default: ''
		},
		role: {
			default: ''
		}
	},

	computed: {
		title: help_user.editusertitle,
		edituser(){
			return this.$store.getters.edituser;
		}
	},

	updated(){
		this.getUser();
	},

	created(){
		this.getUser();
	},

	destroyed(){
		this.$store.commit('UNSET_EDITUSER');
	},

	methods: {
		...help_rest,
		getUser(){
			const self = this;
			if(this.uid == this.olduid && this.role == this.oldrole) return; // brauch kein update
			this.oldrole = this.role;
			this.olduid = this.uid;

			this.data = {}; this.$store.commit('RESET_EDITUSER');
			if(this.uid == 'new'){
				const url = this.$store.getters.channel.urls.user.replace(':id:', this.role);
				this.restoptions(url, {
					partnerid: this.partnerid
				}, 'user-options')
				.then(data => {
					if(data) self.$store.dispatch('SET_EDITUSER', data);
					self.data = data;
				});
			} else {
				const url = this.$store.getters.channel.urls.user.replace(':id:', this.uid);
				this.restget(url, 'user-get')
				.then(data => {
					if(data) self.$store.dispatch('SET_EDITUSER', data);
					self.data = data;
				});
			}

		},
	},
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/PageUser.vue